module.exports = __webpack_public_path__ + "media/images/admin/icons/shield-off-97582b11bdb228c4af53428d081f3dad.svg";